import { KEY_CODES } from "./constants";

export const isEnterHotkey = (keyCode: number) => keyCode === KEY_CODES.Enter;

export const isDeleteHotkey = (keyCode: number) => keyCode === KEY_CODES.Delete;

export const isBackspaceHotkey = (keyCode: number) => keyCode === KEY_CODES.Backspace;

export const isSpaceHotKey = (keyCode: number) => keyCode === KEY_CODES.Space;
